import './FilterInput.css'

import { cap } from '../../../../State'
import { translations } from '../../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/**
 * Componente Input minimal per i filtri
 * @param {Object} props - Proprietà del componente
 * @param {string} props.value - Valore dell'input
 * @param {Function} props.onChange - Funzione chiamata quando cambia il valore
 * @param {Function} props.onClear - Funzione chiamata per pulire il campo
 * @param {string} props.placeholder - Testo placeholder
 * @param {string} props.id - ID univoco per il componente
 * @param {string} props.type - Tipo di input (text, email, etc.)
 * @returns {JSX.Element} Componente Input
 */
export function FilterInput({ value, onChange, onClear, placeholder, id, type = 'text' }) {
  const hasValue = value && value.toString().trim().length > 0

  return (
    <div className="gigi-filter-input-wrapper">
      <input
        type={type}
        id={id}
        className="gigi-filter-input-field"
        value={value || ''}
        onChange={(e) => onChange && onChange(e.target.value)}
        placeholder={placeholder}
      />
      {hasValue && onClear && (
        <button
          type="button"
          className="gigi-filter-clear-button"
          onClick={(e) => {
            e.stopPropagation()
            onClear()
          }}
          title={t.ggPulisci}
        >
          <i className="pi pi-times" />
        </button>
      )}
    </div>
  )
}
